import { render, staticRenderFns } from "./NumberArgument.vue?vue&type=template&id=82930882&scoped=true&"
import script from "./NumberArgument.vue?vue&type=script&lang=js&"
export * from "./NumberArgument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82930882",
  null
  
)

export default component.exports